import { TAccount } from '@helpers/Accounts/accounts.types';

import { TFormalOffer } from './formalOffers.types';

/**
 * Gets the interest-only period on a formal offer
 *
 * @param formalOffer A formal offer object.
 * @returns interest_only_repayments number on the formal offer
 */
export const getFormalOfferInterestOnlyPeriod = (
    formalOffer:
        | TFormalOffer
        | TAccount['latest_formal_offer']
        | TAccount['formal_offers'][number]
): number | undefined => {
    return formalOffer.interest_only_repayments;
};
